module.exports = __webpack_public_path__ + "static/media/search.e47e6444.svg";